"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _Button = require("../../components/Button");

var _Grid = _interopRequireDefault(require("../../components/Grid"));

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _usePrevious = _interopRequireDefault(require("../../utils/usePrevious"));

var _assignRef = _interopRequireDefault(require("../../utils/assignRef"));

var _isCtrlCmd = _interopRequireDefault(require("../../utils/isCtrlCmd"));

var _Option = _interopRequireDefault(require("./Option"));

var _Category = _interopRequireDefault(require("./Category"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _context = require("./context");

var _utils = require("./utils");

var _useListSelectionKeyboardActions = _interopRequireDefault(require("./useListSelectionKeyboardActions"));

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Row = _Grid.default.Row;
var isUsingKeyboard = false;

if (_canUseDOM.default) {
  document.addEventListener('keydown', function () {
    isUsingKeyboard = true;
  });
  document.addEventListener('mousedown', function () {
    isUsingKeyboard = false;
  });
}

var Container = _styledComponents.default.ul.withConfig({
  displayName: "OptionsList__Container",
  componentId: "sc-107p8d5-0"
})(["list-style:none;margin:0;width:100%;height:auto;max-height:", ";max-width:", ";padding:0;overflow:auto;position:relative;", " ", " ", " &:focus{outline:none;}"], (0, _rem.default)(310), (0, _rem.default)(340), function (_ref) {
  var minWidth = _ref.minWidth;
  return minWidth ? "\nmin-width: ".concat(minWidth, ";\n") : '';
}, function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return maxWidth ? "\nmax-width: ".concat(maxWidth, ";\n") : '';
}, function (_ref3) {
  var maxHeight = _ref3.maxHeight;
  return maxHeight ? "\nmax-height: ".concat(maxHeight, ";\n") : '';
});

exports.Container = Container;

function OptionsList(props, forwardedRef) {
  var actions = props.actions,
      items = props.items,
      multiple = props.multiple,
      onChange = props.onChange,
      name = props.name,
      selectedIdsProp = props.selected,
      renderOptionLabel = props.renderOptionLabel,
      borderRadius = props.borderRadius,
      defaultActiveId = props.defaultActiveId,
      activeIdProp = props.activeId,
      onChangeActiveItem = props.onChangeActiveItem,
      onKeyDownProp = props.onKeyDown,
      showCheckbox = props.showCheckbox,
      tabIndex = props.tabIndex,
      selectable = props.selectable,
      _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      defaultSelected = props.defaultSelected,
      itemRole = props.itemRole,
      role = props.role,
      minWidth = props.minWidth,
      maxWidth = props.maxWidth,
      maxHeight = props.maxHeight;
  var initialIds = selectedIdsProp || defaultSelected;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      containerRef = _useState2[0],
      setContainerRef = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _utils.sanitizeIds)(initialIds, !!multiple)),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedIds = _useState4[0],
      setSelectedIds = _useState4[1];

  var updateSelectionAndTriggerChange = (0, _react.useCallback)(function (ids) {
    // Only toggle if we are "uncontrolled"
    selectedIdsProp === undefined && selectable && setSelectedIds(ids);
    onChange && onChange(multiple ? ids : ids[0]);
  }, [multiple, onChange, selectable, selectedIdsProp]); // React to external changes to the selection

  (0, _react.useEffect)(function () {
    if (selectedIdsProp !== undefined) {
      setSelectedIds((0, _utils.sanitizeIds)(selectedIdsProp, !!multiple));
    }
  }, [selectedIdsProp, multiple]);
  var toggleItemSelection = (0, _react.useCallback)(function (itemId) {
    if ( // Bail if we do not recognize the id as selectable
    // !selectableIds.includes(itemId) ||
    // Can't unselect when in single-selection mode
    !multiple && selectedIds.includes(itemId)) {
      return;
    }

    var idsSet = new Set(selectedIds);

    if (selectedIds.includes(itemId)) {
      idsSet.delete(itemId);
    } else {
      !multiple && idsSet.clear();
      idsSet.add(itemId);
    }

    updateSelectionAndTriggerChange(Array.from(idsSet));
  }, [multiple, selectedIds, updateSelectionAndTriggerChange]); // Goes through all the options (categorized or not), and
  // collects the ids of the ones that are **not** disabled.

  var selectableIds = (0, _react.useMemo)(function () {
    return items.reduce(function (acc, item) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(((0, _utils.isCategory)(item) ? item.items.filter(function (_ref4) {
        var disabled = _ref4.disabled;
        return !disabled;
      }) : [item.disabled ? undefined : item]).filter(Boolean)));
    }, []).map(_utils.getId);
  }, [items]);

  var _useState5 = (0, _react.useState)(activeIdProp || defaultActiveId || ''),
      _useState6 = _slicedToArray(_useState5, 2),
      activeId = _useState6[0],
      setActiveId = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      inputMethod = _useState8[0],
      setInputMethod = _useState8[1];

  var previousActiveId = (0, _usePrevious.default)(activeId);
  var updateActiveId = (0, _react.useCallback)(function (newActiveId) {
    setActiveId(newActiveId);
    onChangeActiveItem && onChangeActiveItem(newActiveId);
  }, [onChangeActiveItem, setActiveId]);
  (0, _react.useEffect)(function () {
    if (activeIdProp && activeIdProp !== activeId) {
      setActiveId(activeIdProp);
    }
  }, [activeId, activeIdProp, setActiveId]);
  var handleKeyDown = (0, _react.useCallback)(function (newActiveId, event) {
    newActiveId !== activeId && updateActiveId(newActiveId);
    setInputMethod('keyboard');

    if (['Enter', ' '].includes(event.key)) {
      // "enter" or "space" = select item
      var linkComponent = containerRef && containerRef.querySelector("[data-id=\"".concat(newActiveId, "\"] a"));
      linkComponent && linkComponent.click();
      event.preventDefault(); // Prevent scroll

      toggleItemSelection(newActiveId);
    } // "ctrl + a" = Select/Unselect all


    if (!!multiple && event.key === 'a' && (0, _isCtrlCmd.default)(event)) {
      updateSelectionAndTriggerChange(selectableIds.length === selectedIds.length ? [] : selectableIds);
      event.preventDefault();
    }

    onKeyDownProp && onKeyDownProp(event); // TODO: implement all the other keyboard interactions from here (?):
    // http://w3c.github.io/aria-practices/#listbox_kbd_interaction
  }, [activeId, containerRef, multiple, onKeyDownProp, selectableIds, selectedIds.length, toggleItemSelection, updateActiveId, updateSelectionAndTriggerChange]);

  var _useListSelectionKeyb = (0, _useListSelectionKeyboardActions.default)({
    itemIds: selectableIds,
    callback: handleKeyDown,
    activeItemId: activeId
  }),
      onKeyDown = _useListSelectionKeyb.onKeyDown;

  var handleFocusToggle = (0, _react.useCallback)(function (_event) {
    setInputMethod(isUsingKeyboard ? 'keyboard' : 'mouse');
  }, []); // When using the keyboard, ensure the "active" item is visible.

  (0, _react.useEffect)(function () {
    if (activeId && activeId !== previousActiveId && inputMethod === 'keyboard' && containerRef) {
      (0, _utils.ensureItemIsVisible)(containerRef, activeId);
    }
  }, [containerRef, activeId, inputMethod, previousActiveId]);

  var setContainerRefFunc = function setContainerRefFunc(el) {
    (0, _assignRef.default)(forwardedRef, el);
    setContainerRef(el);
  };

  var onFocus = (0, _react.useCallback)(function (event) {
    var defaultActiveInner = '';

    if (isUsingKeyboard) {
      if (selectedIds) {
        if ((0, _isArray.default)(selectedIds)) {
          // first selectedId is not necessary the first selected dom element
          var firstElement = containerRef && containerRef.querySelector("[aria-selected=\"true\"]");
          defaultActiveInner = (firstElement ? firstElement.getAttribute('data-id') : selectableIds[0]) || '';
        } else {
          defaultActiveInner = selectedIds;
        }
      } else {
        // eslint-disable-next-line prefer-destructuring
        defaultActiveInner = selectableIds[0];
      }

      updateActiveId(defaultActiveInner);
    }

    handleFocusToggle(event);
  }, [containerRef, handleFocusToggle, selectableIds, selectedIds, updateActiveId]);
  var onBlur = (0, _react.useCallback)(function (event) {
    updateActiveId('');
    handleFocusToggle(event);
  }, [handleFocusToggle, updateActiveId]);
  return _react.default.createElement(_context.OptionsListContextProvider, {
    value: {
      toggleItemSelection: toggleItemSelection,
      name: name,
      multiple: !!multiple,
      selectedIds: selectedIds,
      renderOptionLabel: renderOptionLabel,
      inputMethod: inputMethod,
      activeId: activeId,
      setInputMethod: setInputMethod,
      updateActiveId: updateActiveId,
      selectable: !!selectable,
      itemRole: itemRole
    }
  }, _react.default.createElement(_Grid.default.Container, null, _react.default.createElement(Row, null, _react.default.createElement(Container, {
    "aria-activedescendant": activeId,
    "aria-multiselectable": !!multiple,
    ref: setContainerRefFunc,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseLeave: function onMouseLeave() {
      return updateActiveId('');
    },
    role: role,
    tabIndex: tabIndex,
    minWidth: minWidth,
    maxWidth: maxWidth,
    maxHeight: maxHeight
  }, items.map(function (item) {
    var id = (0, _utils.getId)(item);

    if ((0, _utils.isCategory)(item)) {
      return _react.default.createElement(_Category.default, _extends({}, item, {
        key: id,
        borderRadius: borderRadius,
        showCheckbox: showCheckbox,
        size: size
      }));
    }

    return _react.default.createElement(_Option.default, _extends({}, item, {
      key: id,
      borderRadius: borderRadius,
      showCheckbox: showCheckbox,
      size: size
    }));
  }))), actions && _react.default.createElement(Row, null, _react.default.createElement(_Footer.default, {
    actions: actions
  }))));
}

var OptionsListWithContainerRef = (0, _react.forwardRef)(OptionsList); // @ts-ignore

OptionsListWithContainerRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  actions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
    id: _propTypes.default.string.isRequired
  }))), _propTypes.default.shape({
    left: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    }))),
    right: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    })))
  })])
});
OptionsListWithContainerRef.defaultProps = {
  role: 'listbox',
  itemRole: 'option',
  tabIndex: 0,
  selectable: true,
  showCheckbox: true,
  size: 'small'
};
var _default = OptionsListWithContainerRef;
exports.default = _default;